import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useKeenSlider } from 'keen-slider/react'
import { Box, Heading } from '@radix-ui/themes'
import cn from 'clsx'

import { Image } from '~/components/ui/image'
import { INDEX_I18NEXT } from '~/routes/($lang)._index/index.component'


const partners = [
	{ img: '/pwa/img/compress/partners/estg_logo.webp', title: 'estg', link: 'https://www.estg.eu/de-de/' },
	{ img: '/pwa/img/compress/partners/ews_pv_logo.webp', title: 'ews pv', link: 'https://www.pv.de/' },
	{ img: '/pwa/img/compress/partners/it_solartechnik_logo_color.webp', title: 'it solartechnik', link: 'https://www.it-solartechnik.de/' },
	{ img: '/pwa/img/compress/partners/memodo_logo.svg', title: 'memodo', link: 'https://www.memodo.de/' },
	{ img: '/pwa/img/compress/partners/tesla_logo.svg', title: 'tesla', link: 'https://www.tesla.com/' },
]

const Partners: React.FC = () => {
	const { t } = useTranslation(INDEX_I18NEXT.routeIndex)

  const animation = { duration: 50000, easing: (t: number) => t }
  const [isMounted, setIsMounted] = React.useState(false)

  const [ref, slider] = useKeenSlider<HTMLDivElement>({
    loop: true,
    renderMode: 'performance',
    mode: 'free',
    slides: { origin: 'center', perView: () => Math.min(window.innerWidth / 300, 3.5), spacing: 80 },
    created(s) {
      setIsMounted(true)
      s.moveToIdx(5, true, animation)
    },
    updated(s) {
      s.moveToIdx(s.track.details.abs + 5, true, animation)
    },
    animationEnded(s) {
      s.moveToIdx(s.track.details.abs + 5, true, animation)
    },
  })

	return (
		<div className="flex flex-col gap-y-12 items-center my-12 mt-32">
			<Heading color="green" weight="medium" size="7">
				{t(`common.partners.title`)}
			</Heading>
      <div
        ref={ref}
        className={cn({
          'opacity-100': isMounted,
        },'keen-slider')}
        onMouseEnter={() => {
          if (slider.current) {
            slider.current.animator.stop()
          }
        }}
        onMouseLeave={() => {
          if (slider.current) {
            slider.current.moveToIdx(
              slider.current.track.details.abs + 5,
              true,
              animation
            )
          }
        }}
      >
				{partners.map(({ img, title, link }) => (
					<a
						key={title}
						href={link}
						target="_blank"
						rel="noreferrer"
            className="keen-slider__slide flex justify-center items-center"
					>

              <Image
                api={false}
                src={img}
                alt={title}
              />

					</a>
				))}
			</div>
		</div>
	)
}


export { Partners }
